import { IconWrapper } from '../runtime';
export default IconWrapper('unknown_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.7005 4.35185C11.1105 3.80942 10.3022 3.54637 9.55664 3.484C8.80958 3.4215 7.97717 3.5477 7.308 3.95637C6.64732 4.35985 6.17314 4.84587 5.88231 5.45167C5.59875 6.04233 5.53125 6.662 5.53125 7.2541V7.30762H7.40625V7.2541C7.40625 6.79194 7.46239 6.49275 7.57262 6.26314C7.67557 6.04868 7.86532 5.81301 8.28524 5.55657C8.52997 5.40711 8.9382 5.31381 9.40032 5.35247C9.86394 5.39126 10.2334 5.55004 10.4315 5.73216C10.864 6.12976 11.0659 6.60888 11.0625 7.08911C11.059 7.57062 10.8473 8.15171 10.2658 8.7323C9.5395 9.45757 9.18153 9.81363 9.00548 9.98804C8.91707 10.0756 8.87615 10.1158 8.85806 10.1334L8.85429 10.1371C8.84703 10.1438 8.83985 10.1507 8.83276 10.1577C8.68179 10.3071 8.54129 10.4909 8.45232 10.7275C8.36592 10.9573 8.35517 11.1672 8.35517 11.3115V11.9063H10.2302V11.4139C10.2545 11.3899 10.2855 11.3592 10.3251 11.32C10.5039 11.1429 10.864 10.7847 11.5907 10.0591C12.4623 9.1888 12.9299 8.15438 12.9374 7.10243C12.9449 6.0492 12.4892 5.07693 11.7005 4.35185Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.2188 13.0313H8.34375V14.9063H10.2188V13.0313Z",
      "fill": "white"
    }
  })]);
});